import React from 'react'
import Grid from 'material-ui/Grid'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import TextField from 'material-ui/TextField'

export const SimpleTextField = ({ input, meta: { touched, active, error }, ...rest }) => (
  <div className="form-group-mui">
    <TextField fullWidth error={!!error} {...input} {...rest} />
  </div>
)

export default ({
  input,
  errors,
  label,
  helperText,
  meta: { touched, active, error },
  ...rest
}) => (
  <Grid container className="form-group-mui">
    <Grid item xs={12}>
      <FormControl fullWidth {...rest}>
        <Grid container>
          <Grid item md={3} sm={12} xs={12}>
            <InputLabel htmlFor={input.name} shrink>
              {label}
            </InputLabel>
          </Grid>
          <Grid item md={9} sm={12} xs={12}>
            <Input
              fullWidth
              error={!!error || (errors && errors[input.name])}
              {...input}
              {...rest}
            />
          </Grid>
        </Grid>
      </FormControl>
    </Grid>
    {helperText && (
      <Grid item xs={12} className="form-token-msg">
        <Grid container justify="flex-end">
          <Grid item md={9} sm={12} xs={12}>
            <FormHelperText>{helperText}</FormHelperText>
          </Grid>
        </Grid>
      </Grid>
    )}
  </Grid>
)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/edit/group.js